import { render } from "./ChooseSongSing.vue?vue&type=template&id=38a18ae8"
import script from "./ChooseSongSing.vue?vue&type=script&lang=js"
export * from "./ChooseSongSing.vue?vue&type=script&lang=js"

import "./ChooseSongSing.vue?vue&type=style&index=0&id=38a18ae8&lang=css"

import exportComponent from "/Users/nadiacarvalho/Documents/Projects/COPOEM/co-poem/frontend-games/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__